import './input-field-pager.scss';

import { PropsWithChildren } from 'react';

import { Button, ButtonIcon, ButtonType } from '../button/button';

type InputFieldPagerProps = PropsWithChildren<{
  disabledPrev?: boolean;
  disabledNext?: boolean;
  onClickPrev?: () => void;
  onClickNext?: () => void;
}>;

export function InputFieldPager({
  disabledPrev = false,
  disabledNext = false,
  onClickPrev,
  onClickNext,
  ...props
}: InputFieldPagerProps) {
  return (
    <div className="form-group-pager">
      <div className="form-group-pager__prev">
        <Button
          type={ButtonType.TRANSPARENT}
          icon={ButtonIcon.CHEVRON_LEFT}
          disabled={!onClickPrev || disabledPrev}
          onClick={onClickPrev}
        />
      </div>
      <div className="form-group-pager__content">{props.children}</div>
      <div className="form-group-pager__next">
        <Button
          type={ButtonType.TRANSPARENT}
          icon={ButtonIcon.CHEVRON_RIGHT}
          disabled={!onClickNext || disabledNext}
          onClick={onClickNext}
        />
      </div>
    </div>
  );
}
